/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { Grid, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { KgIcon, PieceIcon, VolumeIcon } from '../../../../../components/text-icon';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import { FormTextAreaField } from '../../../../../semantic-ui/components/form-textarea-field';
import { CustomLoader } from '../../../../../components/custom-loader';
import { CustomDatePicker } from '../../../../../semantic-ui/components/custom-datepicker';
import { ErrorComponent } from '../../../../../components/error-component';
import { FormCheckboxField } from '../../../../../semantic-ui/components/form-checkbox-field';
import { CargoFetchBadge } from '../../cargo-fetch-badge';

export const CargoFetchFormView = ({ reqInfo, isReqInfoLoading, isActive }) => {
	if (isReqInfoLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="cargo-fetch-form">
			<Grid.Row className="cargo-fetch-form__row-header">
				<Grid.Column width={16} className="cargo-fetch-form__column-header">
					<header className="cargo-fetch-form__header">
						<span className="cargo-fetch-form__header-text cargo-fetch-form__header-text_min-weight ">
							<span className="cargo-fetch-form__header-text cargo-fetch-form__header-text_bold">{`Заявка № ${reqInfo.id}`}</span>
							{` от ${reqInfo.created_at}`}
						</span>
						<span className="cargo-fetch-form__header-text">
							{`${reqInfo?.company?.name} `}
							<span className="cargo-fetch-form__header-text cargo-fetch-form__header-text_small">
								{reqInfo?.company?.address}
							</span>
						</span>
					</header>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Фактическая дата прибытия
				</Grid.Column>
				<Grid.Column className="cargo-fetch-form__column cargo-fetch-form__column-date">
					<Field
						name="date_arrival"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=". . / . . / . . . ."
						dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						isWithoutErrorText
					/>
				</Grid.Column>
				<Grid.Column width={2} className="cargo-fetch-form__column">
					Время
				</Grid.Column>
				<Grid.Column className="cargo-fetch-form__column cargo-fetch-form__column-time">
					<Field
						name="time_arrival"
						type="time"
						component={FormInputField}
						autoComplete="off"
						placeholder="00:00"
						isWithoutErrorText
					/>
				</Grid.Column>
				<Grid.Column width={16} className="cargo-fetch-form__column__error">
					<Field name="date_arrival" component={ErrorComponent} />
					<Field name="time_arrival" component={ErrorComponent} />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Фактическая дата убытия
				</Grid.Column>
				<Grid.Column className="cargo-fetch-form__column cargo-fetch-form__column-date">
					<Field
						name="date_departure"
						type="text"
						component={CustomDatePicker}
						autoComplete="off"
						placeholder=". . / . . / . . . ."
						dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						isWithoutErrorText
					/>
				</Grid.Column>
				<Grid.Column width={2} className="cargo-fetch-form__column">
					Время
				</Grid.Column>
				<Grid.Column className="cargo-fetch-form__column cargo-fetch-form__column-time">
					<Field
						name="time_departure"
						type="time"
						component={FormInputField}
						autoComplete="off"
						placeholder="00:00"
						isWithoutErrorText
					/>
				</Grid.Column>
				<Grid.Column width={16} className="cargo-fetch-form__column__error">
					<Field name="date_departure" component={ErrorComponent} />
					<Field name="time_departure" component={ErrorComponent} />
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Характер груза
				</Grid.Column>
				<Grid.Column width={7} className="cargo-fetch-form__column">
					<Field
						name="type"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите характер груза"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Состояние груза
				</Grid.Column>
				<Grid.Column width={7} className="cargo-fetch-form__column">
					<Field
						name="state"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите состояние груза"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row-list">
				<Grid.Column width={16} className="cargo-fetch-form__column-list">
					<ul className="cargo-fetch-form__route-list">
						{reqInfo.points?.map((el, key) => {
							return (
								<li key={el.id} className="cargo-fetch-form__route-item">
									<header className="cargo-fetch-form__route-header">
										<Popup
											content="Выберите забранный груз"
											trigger={
												<div className="cargo-fetch-form__checkbox-wrapper">
													<Field
														name={`points.[${key}].is_fetch`}
														type="checkbox"
														component={FormCheckboxField}
													/>
												</div>
											}
											position="right center"
											size="mini"
											inverted
											style={{
												textAlign: 'center',
												fontSize: 12,
												fontWeight: '500',
												marginLeft: '12px',
											}}
										/>
										<span className="cargo-fetch-form__route-title cargo-fetch-form__route-title_small">
											{`#${el.id}, ${el.company}, ${el.address}`}
										</span>
									</header>
									<div className="cargo-fetch-form__route-info-field">
										<div className="cargo-fetch-form__route-info-item">
											<CargoFetchBadge text={el.weight ?? '-'} isSmall />
											<span className="cargo-fetch-form__route-info-text">кг</span>
										</div>
										<div className="cargo-fetch-form__route-info-item">
											<CargoFetchBadge text={el.volume ?? '-'} isSmall />
											<span className="cargo-fetch-form__route-info-text">м³</span>
										</div>
										<div className="cargo-fetch-form__route-info-item">
											<CargoFetchBadge text={el.place ?? '-'} isSmall />
											<span className="cargo-fetch-form__route-info-text">шт</span>
										</div>
										<div className="cargo-fetch-form__route-info-item">
											<CargoFetchBadge
												text={el.date ? moment(el.date).format('DD.MM.YYYY') : '-'}
											/>
											<span className="cargo-fetch-form__route-info-text">дата доставки</span>
										</div>
									</div>
									<Grid className="cargo-fetch-form">
										<Grid.Row className="cargo-fetch-form__row">
											<Grid.Column width={6} className="cargo-fetch-form__column">
												Тип места
											</Grid.Column>
											<Grid.Column width={7} className="cargo-fetch-form__column">
												<Field
													name={`points.[${key}].type_seat`}
													type="text"
													component={FormInputField}
													autoComplete="off"
													placeholder="Укажите тип места"
													disabled={!isActive.points[key]}
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="cargo-fetch-form__row">
											<Grid.Column width={6} className="cargo-fetch-form__column">
												Масса брутто груза
											</Grid.Column>
											<Grid.Column width={7} className="cargo-fetch-form__column">
												<Field
													name={`points.[${key}].weight`}
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													icon={KgIcon}
													placeholder="Укажите массу брутто груза"
													disabled={!isActive.points[key]}
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="cargo-fetch-form__row">
											<Grid.Column width={6} className="cargo-fetch-form__column">
												Объем груза
											</Grid.Column>
											<Grid.Column width={7} className="cargo-fetch-form__column">
												<Field
													name={`points.[${key}].volume`}
													type="text"
													normalize={normalizeNumber}
													component={FormInputField}
													autoComplete="off"
													icon={VolumeIcon}
													placeholder="Укажите объем груза"
													disabled={!isActive.points[key]}
												/>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row className="cargo-fetch-form__row">
											<Grid.Column width={6} className="cargo-fetch-form__column">
												Кол-во грузовых мест
											</Grid.Column>
											<Grid.Column width={7} className="cargo-fetch-form__column">
												<Field
													name={`points.[${key}].place`}
													type="text"
													normalize={normalizeInteger}
													component={FormInputField}
													autoComplete="off"
													icon={PieceIcon}
													placeholder="Укажите кол-во грузовых мест"
													disabled={!isActive.points[key]}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</li>
							);
						})}
					</ul>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Фактическое состояние тары при приемке
				</Grid.Column>
				<Grid.Column width={7} className="cargo-fetch-form__column">
					<Field
						name="container_state"
						type="text"
						component={FormTextAreaField}
						autoComplete="off"
						width="100%"
						resize="vertical"
						placeholder="Укажите фактическое состояние тары при приемке"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Фактическое состояние упаковки при приемке
				</Grid.Column>
				<Grid.Column width={7} className="cargo-fetch-form__column">
					<Field
						name="packaging_state"
						type="text"
						component={FormTextAreaField}
						autoComplete="off"
						width="100%"
						resize="vertical"
						placeholder="Укажите фактическое состояние упаковки при приемке"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="cargo-fetch-form__row">
				<Grid.Column width={6} className="cargo-fetch-form__column">
					Фактическое состояние кузова при приемке
				</Grid.Column>
				<Grid.Column width={7} className="cargo-fetch-form__column">
					<Field
						name="body_state"
						type="text"
						component={FormTextAreaField}
						autoComplete="off"
						width="100%"
						resize="vertical"
						placeholder="Укажите фактическое состояние кузова при приемке"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

CargoFetchFormView.propTypes = {
	reqInfo: PropTypes.object,
	isReqInfoLoading: PropTypes.bool,
	isActive: PropTypes.object,
};
